module.exports = __webpack_public_path__ + "img/multiple-download-icon.91600e4d.svg";